import { useEffect, useState } from "react";
import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../../firebase";
import {
    BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer,
} from "recharts";

const StatsOverview = () => {
    const [agentCount, setAgentCount] = useState(0);
    const [bookingCount, setBookingCount] = useState(0);
    const [bookingChartData, setBookingChartData] = useState([]);

    useEffect(() => {
        fetchStats();
    }, []);

    const fetchStats = async () => {
        // Aantal makelaars
        const agentSnap = await getDocs(query(collection(db, "users"), where("role", "==", "agent")));
        setAgentCount(agentSnap.size);

        // Aantal boekingen
        const bookingsSnap = await getDocs(collection(db, "bookings"));
        setBookingCount(bookingsSnap.size);

        // Boekingen per dag (laatste 7 dagen)
        const bookings = bookingsSnap.docs.map((doc) => doc.data());
        const dailyCounts = {};

        bookings.forEach((booking) => {
            const date = booking.createdAt?.toDate?.().toLocaleDateString("nl-NL") || "Onbekend";
            dailyCounts[date] = (dailyCounts[date] || 0) + 1;
        });

        const sortedData = Object.entries(dailyCounts)
            .map(([date, count]) => ({ date, count }))
            .sort((a, b) => new Date(a.date) - new Date(b.date))
            .slice(-7); // laatste 7 dagen

        setBookingChartData(sortedData);
    };

    return (
        <div className="grid gap-6 mb-10 sm:grid-cols-2 lg:grid-cols-3">
            {/* Statistiek blokken */}
            <div className="bg-white p-4 shadow rounded">
                <p className="text-sm text-gray-500">Aangesloten makelaars</p>
                <h2 className="text-2xl font-bold">{agentCount}</h2>
            </div>
            <div className="bg-white p-4 shadow rounded">
                <p className="text-sm text-gray-500">Totaal boekingen</p>
                <h2 className="text-2xl font-bold">{bookingCount}</h2>
            </div>
            <div className="bg-white p-4 shadow rounded col-span-full">
                <p className="text-sm text-gray-500 mb-2">Boekingen per dag</p>
                <ResponsiveContainer width="100%" height={200}>
                    <BarChart data={bookingChartData}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="date" />
                        <YAxis allowDecimals={false} />
                        <Tooltip />
                        <Bar dataKey="count" fill="#3B82F6" />
                    </BarChart>
                </ResponsiveContainer>
            </div>
        </div>
    );
};

export default StatsOverview;
